












































import { Component, Prop, Vue } from "@/shared/vuepack";
import { useAuthorizedSignerStore } from "@/employer/store/authorizedSigner";
import { AuthorizedSigner, AuthorizedSignerStatus } from "@/shared/types";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import { lastFour as ssnLastFour } from "@/shared/ssn";
import { format as formatPhone } from "@/shared/phone";
import _ from "lodash";
import AccountHolderWidgetBase from "@/employer/components/partner-ee-service/AccountHolderWidgetBase.vue";
import Pill from "@/shared/components/ui/Pill.vue";

interface AuthorizedSignerTableItem {
  id: number;
  name: string;
  dateOfBirth: string;
  ssn: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  isActive: boolean;
}

@Component({
  components: {
    AccountHolderWidgetBase,
    Pill
  }
})
export default class AccountHolderAuthorizedSigners extends Vue {
  authorizedSignerStore = useAuthorizedSignerStore();

  @Prop({ required: true })
  username: string;

  @Prop({ required: true })
  partnerId: number;

  get isLoading () {
    return this.authorizedSignerStore.isLoading;
  }

  get isLoaded () {
    return this.authorizedSignerStore.isLoaded;
  }

  get isFailed () {
    return this.authorizedSignerStore.isFailed;
  }

  get authorizedSigners (): AuthorizedSignerTableItem[] {
    const authSigners = Object.keys(this.authorizedSignerStore.authorizedSigners)
      .map(id => this.authorizedSignerStore.authorizedSigners[id]);
    const items = authSigners.map(authSigner => ({
      id: authSigner.id,
      name: this.getName(authSigner),
      dateOfBirth: formatMMddyyyyDateString(authSigner.dateOfBirth),
      ssn: authSigner.ssn ? ssnLastFour(authSigner.ssn) : "",
      address1: authSigner.address1,
      address2: authSigner.address2,
      city: authSigner.city,
      state: authSigner.state,
      zip: authSigner.zip,
      phone: formatPhone(authSigner.phone),
      isActive: authSigner.status === AuthorizedSignerStatus.Active
    }));

    return _.sortBy(items, authSigner => !authSigner.isActive, authSigner => authSigner.name);
  }

  loadData () {
    this.authorizedSignerStore.loadAuthorizedSigners({
      username: this.username,
      partnerId: this.partnerId
    });
  }

  get hasData () {
    return this.isLoaded && this.authorizedSigners.length > 0;
  }

  getName (authSigner: AuthorizedSigner) {
    if (authSigner.middleInitial) {
      return `${authSigner.firstName} ${authSigner.middleInitial} ${authSigner.lastName}`;
    }

    return `${authSigner.firstName} ${authSigner.lastName}`;
  }
}
